import SearchResult, {
  SearchResultList
} from "@/src/common/components/GlobalSearchModal/SearchResult"
import React, { Fragment } from "react"

export type RecentSearchItem = SearchResultList

type RecentlyVisitedPageProps = {
  recentSearches: RecentSearchItem[]
  onClickSearch?: (search: RecentSearchItem) => void
}

const RecentlyVisitedPage = ({
  recentSearches,
  onClickSearch
}: RecentlyVisitedPageProps) => {
  return (
    <Fragment>
      <h3 className="text-gray-400 text-[10px] px-5 py-1">Recently Visited</h3>
      <SearchResult
        searchList={recentSearches}
        onClickResult={(item) => onClickSearch?.(item)}
      />
    </Fragment>
  )
}

export default RecentlyVisitedPage
